var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('file-importer-view',{attrs:{"LastImportedTransactions":_vm.lastImportedTransactions},on:{"save-transactions":_vm.saveTransactions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }